import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/kpi-reports/versions')({
  staticData: toStaticData(CRT_ROUTES['/crt/kpi-reports/versions']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
